<template>
  <div class="page">
    <div class="sidebar">
      <div class="logo">
        <img width="220px" src="@/assets/gis/caso.png" alt="" />
      </div>

      <div class="list">
        <router-link to="/personal" :class="{ active: isActive('/personal') }">
          <div class="real">
            <img src="@/assets/svg/gis-home.svg" alt="" />
            <span>Home</span>
          </div>
        </router-link>

        <router-link to="/map" :class="{ active: isActive('/map') }">
          <div class="real">
            <img src="@/assets/svg/gis-map.svg" alt="" />
            <span>map</span>
          </div>
        </router-link>

        <router-link to="/detail" :class="{ active: isActive('/detail') }">
          <div class="real">
            <img src="@/assets/svg/gis-sql.svg" alt="" />
            <span>数据库</span>
          </div>
        </router-link>

        <router-link :to="currentUserName == null ? goinurl.yes : goinurl.no">
          <div class="real">
            <el-col :span="12">
              <el-popover placement="bottom" width="200" trigger="hover">
                <!-- <el-button slot="reference">hover 激活</el-button> -->
                <span class="el-dropdown-link" slot="reference">
                  <el-avatar :size="40" :src="hpSrc"></el-avatar>
                  <span class="name"
                    >{{ currentUserName === null ? "登录" : currentUserName }}
                  </span>
                </span>
                <div class="info-content" v-if="Authorization">
                  <div class="vip" v-if="vipInfo">
                    <span>
                      会员有效期至 <br />
                      <span class="c">{{
                        vipInfo.expireTime &&
                        parseTime(vipInfo.expireTime).substring(0, 10)
                      }}</span>
                    </span>
                    <span class="c cur" @click="vipShow">立即续费</span>
                  </div>
                  <div class="vip-download" v-if="vipInfo">
                    <div>
                      日历史数据下载:
                      <span class="c cur">{{ vipInfo.dayFile }}</span
                      >次
                    </div>
                    <div>
                      周历史数据下载:
                      <span class="c cur">{{ vipInfo.weekFile }}</span
                      >次
                    </div>
                    <div>
                      月历史数据下载:
                      <span class="c cur">{{ vipInfo.monthFile }}</span
                      >次
                    </div>
                  </div>
                  <div class="vip" v-if="!vipInfo">
                    <span> <span class="">您还不是会员</span> </span>
                    <span class="c cur" @click="vipShow">立即开通</span>
                  </div>
                  <div class="list-con">
                    <router-link class="list-i" to="/gislist">
                      <span>气象站管理</span>
                      <i class="el-icon-message-solid" size="18"></i>
                    </router-link>
                    <router-link class="list-i" to="/gisuser">
                      <span>用户信息</span>
                      <i class="el-icon-user-solid" size="18"></i>
                    </router-link>
                    <div class="list-i" @click="logout">
                      <span>退出登录</span>
                      <i class="el-icon-close" size="18"></i>
                    </div>
                  </div>
                </div>
              </el-popover>
              <!-- <el-dropdown>
                <span class="el-dropdown-link">
                  <el-avatar size="20" :src="hpSrc"></el-avatar>
                  <span class="name">{{ currentUserName === null ? '登录': currentUserName}} </span>
                </span>
                <el-dropdown-menu slot="dropdown"
                                  :class="{'no_goin':currentUserName == null}">
                  <el-dropdown-item icon="el-icon-message-solid"> <router-link to="/gislist"
                                 style="color: #666;">气象站管理</router-link></el-dropdown-item>
                  <el-dropdown-item icon="el-icon-user-solid"> <router-link to="/gisuser"
                                 style="color: #666;">用户信息</router-link></el-dropdown-item>
                  <el-dropdown-item icon="el-icon-close"> <i @click="logout"
                       style="color: #666;">退出登录</i></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </el-col>
          </div>
        </router-link>
      </div>
    </div>

    <div class="content-container">
      <router-view></router-view>
    </div>

    <el-dialog
      title="购买会员"
      :visible.sync="dialogVisible"
      width="80%"
      @close="dialogVisible = false"
      :before-close="handleClose"
    >
      <div class="vip-container">
        <div class="is-bill">
          是否开发票：
          <el-switch v-model="noBill" active-color="#13ce66"> </el-switch>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="会员套餐" name="1">
            <div class="vip-content">
              <div
                class="vc-i"
                v-for="item in comboList"
                :key="item.key"
                @click="comboActive = item.menuId"
                :class="{ active: comboActive == item.menuId }"
              >
                <div class="vc-title">
                  <span v-if="item.menuName != '普通用户'"
                    >{{ item.menuTime }}天</span
                  >{{ item.menuName }}
                </div>
                <div class="vc-item">
                  <span>地图站点数据实时查看</span>
                  <i class="el-icon-check" size="18"></i>
                </div>
                <div class="vc-item">
                  <span>各站点实时详细数据查看</span>
                  <i class="el-icon-check" size="18"></i>
                </div>
                <div class="vc-item">
                  <span>部分网站PPT学习资源</span>
                  <i class="el-icon-check" size="18"></i>
                </div>
                <div class="vc-item">
                  <span>全部网站PPT学习资源 </span>
                  <i
                    v-if="item.menuName != '普通用户'"
                    class="el-icon-check"
                    size="18"
                  ></i>
                </div>
                <div class="vc-item">
                  <span>历史数据在线查看</span>
                  <i
                    v-if="item.menuName != '普通用户'"
                    class="el-icon-check"
                    size="18"
                  ></i>
                </div>
                <div class="vc-item">
                  <span>日历史数据下载 </span>
                  <span class="vc-item-num">{{ item.dayFile }}次</span>
                </div>
                <div class="vc-item">
                  <span>周历史数据下载</span>
                  <span class="vc-item-num">{{ item.weekFile }}次</span>
                </div>
                <div class="vc-item">
                  <span>月历史数据下载 </span>
                  <span class="vc-item-num">{{ item.monthFile }}次</span>
                </div>
                <div class="price" v-if="item.menuName != '普通用户'">
                  ￥{{ noBill ? item.menuPrice : item.noBillPrice }}
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="加油包套餐" name="2">
            <div class="vip-content">
              <div
                class="vc-i"
                v-for="item in appendList"
                :key="item.key"
                @click="comboActive = item.menuId"
                :class="{ active: comboActive == item.menuId }"
              >
                <div class="vc-title">
                  <span v-if="item.menuName != '普通用户'"></span
                  >{{ item.menuName }}
                </div>
                <div class="vc-item">
                  <span>地图站点数据实时查看</span>
                  <i class="el-icon-check" size="18"></i>
                </div>
                <div class="vc-item">
                  <span>各站点实时详细数据查看</span>
                  <i class="el-icon-check" size="18"></i>
                </div>
                <div class="vc-item">
                  <span>部分网站PPT学习资源</span>
                  <i class="el-icon-check" size="18"></i>
                </div>
                <div class="vc-item">
                  <span>全部网站PPT学习资源 </span>
                  <i
                    v-if="item.menuName != '普通用户'"
                    class="el-icon-check"
                    size="18"
                  ></i>
                </div>
                <div class="vc-item">
                  <span>历史数据在线查看</span>
                  <i
                    v-if="item.menuName != '普通用户'"
                    class="el-icon-check"
                    size="18"
                  ></i>
                </div>
                <div class="vc-item">
                  <span>日历史数据下载 </span>
                  <span class="vc-item-num">{{ item.dayFile }}次</span>
                </div>
                <div class="vc-item">
                  <span>周历史数据下载</span>
                  <span class="vc-item-num">{{ item.weekFile }}次</span>
                </div>
                <div class="vc-item">
                  <span>月历史数据下载 </span>
                  <span class="vc-item-num">{{ item.monthFile }}次</span>
                </div>
                <div class="price" v-if="item.menuName != '普通用户'">
                  ￥{{ noBill ? item.menuPrice : item.noBillPrice }}
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="k-vip">
          <div class="vip-btn" @click="sendOrderHandle">立即开通</div>

          <!-- <div class="vip-btn" v-if="qrUrl" @click="payComplete">支付完成</div> -->
        </div>
      </div>

      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
    <el-dialog
      title="扫码支付"
      :visible.sync="qrcodeVisible"
      width="80%"
      @close="qrcodeVisible = false"
    >
      <div style="display: flex; justify-content: center">
        <canvas class="qrcode" v-if="qrUrl" ref="qrCanvas"></canvas>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import hp from "@/assets/hp.png";
import { $user as $userAdmin } from "@/services/admin";
import QRCode from "qrcode";
export default {
  name: "GISHome",
  data() {
    let charvb = {
      xAxis: {
        data: ["12:00", "13:00", "14:00", "15:00", "16:00", "17:00"],
      },
      grid: {
        top: "10%",
        bottom: "15%",
      },
      yAxis: {},
      series: [
        {
          smooth: true,
          type: "line",
          color: "#00479D",
          data: [5, 10, 15, 12, 8, 6],
        },
      ],
    };
    return {
      goinurl: {
        yes: "/login",
        no: "/gisuser",
      },
      hpSrc: hp,
      charvb,
      visible: false,
      no_goin: true,
      dialogVisible: false,
      comboList: [],
      comboActive: "",
      activeName: "1",
      appendList: [], // 加油包
      qrUrl: "",
      vipInfo: null,
      inter: null,
      orderId: "",
      noBill: false,
      qrcodeVisible: false,
    };
  },
  computed: {
    vipInfoUpdate() {
      return this.$store.getters.vipInfoUpdate || 0;
    },
    // [重构] 通过 mapState 直接映射 Vuex 中的用户信息和 Token
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      currentUserName: (state) => state.user.name,
      Authorization: (state) => state.user.token,
    }),
  },
  watch: {
    vipInfoUpdate() {
      if (this.vipInfoUpdate == 1) {
        this.getVipInfo();
        this.$store.commit("SET_vipInfoUpdate", 0);
      } else if (this.vipInfoUpdate == 2) {
        this.vipShow();
        this.$store.commit("SET_vipInfoUpdate", 0);
      }
    },
    qrcodeVisible() {
      if (!this.qrcodeVisible) {
        this.qrUrl = "";
      }
    },
  },
  created() {
    this.crea();
    if (this.Authorization) {
      this.getVipInfo();
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        this.$router.push("/map");
      });
    },
    async getVipInfo() {
      let res = await $userAdmin.vipInfo();
      if (res.code == 200) {
        this.vipInfo = res.data;
      }
    },
    handleClick() {
      this.comboActive = "";
    },
    async vipShow() {
      let res = await $userAdmin.memberList();
      if (res.code == 200) {
        this.comboList = res.data;
      }
      let res1 = await $userAdmin.appendList();
      if (res1.code == 200) {
        this.appendList = res1.data;
      }
      this.dialogVisible = true;
    },
    async sendOrderHandle() {
      let userInfo = this.userInfo;
      if (!userInfo.email) {
        this.$message.error("请先完善邮箱信息！");
        return false;
      }
      let data = {
        id: this.comboActive,
        type: this.activeName, // 1  会员 2 加油包
        noBill: !this.noBill,
        email: userInfo.email,
      };
      let res = await $userAdmin.payMember(data);

      if (res.code == 200) {
        this.orderId = res.data.orderId;
        this.qrUrl = res.data.url;
        this.dialogVisible = false;
        this.qrcodeVisible = true;
        setTimeout(() => {
          this.payment();
          this.generateQrCode();
        }, 1000);
      }
    },
    generateQrCode() {
      QRCode.toCanvas(
        this.$refs.qrCanvas,
        this.qrUrl,
        { width: 200, height: 200 },
        (err) => {
          if (err) {
            console.error("生成二维码失败：", err);
          }
        }
      );
    },

    payment() {
      // 支付完成
      if (this.inter) {
        clearInterval(this.inter);
      }
      this.inter = setInterval(() => {
        $userAdmin
          .orderInfo(this.orderId)
          .then((res) => {
            if (res.code == 200 && res.data.orderStatus == 5) {
              this.$message.success("会员购买成功！");
              this.getVipInfo();
              this.dialogVisible = false;
              clearInterval(this.inter);
            }
          })
          .catch(() => {
            this.$message.error("支付失败！");
            clearInterval(this.inter);
            this.dialogVisible = false;
            this.getVipInfo();
          });
      }, 3000);
    },
    handleClose(done) {
      if (this.inter) {
        clearInterval(this.inter);
      }
      done();
    },

    isActive(route) {
      return this.$route.path === route;
    },
    crea() {
      if (this.currentUserName === null) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    goHome() {
      this.$router.push("/map");
    },
    goLogin() {
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
    },
  },
  destroyed() {
    if (this.inter) {
      clearInterval(this.inter);
    }
  },
};
</script>
<style lang="less" scoped>
.active {
  background-color: rgb(0, 106, 145);
}
.no_goin {
  display: none;
}
.page {
  // font-family: Roboto,"Helvetica Neue",Helvetica,Arial,sans-serif;
  font-family: "微软雅黑";
  position: relative;
  .sidebar {
    background-color: #08b;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 100px;

    .list {
      display: flex;
      height: 50px;
      a {
        color: #fff;
        display: flex;
        align-items: center;
        padding: 0 15px;

        img {
          width: 16px;
          height: 16px;
          margin-right: 3px;
          vertical-align: bottom;
        }
      }
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  width: 100px;
  font-size: 16px;
  position: relative;
  .le {
    position: absolute;
    bottom: 2px;
    color: rgb(255, 102, 153);
    width: 40px;
    text-align: center;
    z-index: 10;
  }
  .name {
    margin-left: 3px;
  }
}
.el-icon-arrow-down {
  font-size: 30px;
}

.info-content {
  padding: 10px;
  .vip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    height: 42px;
    margin-bottom: 20px;
    .c {
      color: rgb(255, 102, 153);
    }
    .cur {
      cursor: pointer;
    }
  }
  .vip-download {
    margin-top: -15px;
    margin-bottom: 20px;
    .c {
      color: rgb(255, 102, 153);
    }
  }
  .list-con {
    .list-i {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      height: 36px;
      cursor: pointer;
      color: #61666d;
    }
  }
}
.vip-container {
  position: relative;
  .is-bill {
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 99;
  }
  .k-vip {
    display: flex;
    justify-content: space-around;
  }
  .vip-btn {
    width: 200px;
    height: 42px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #fff;
    background: rgb(255, 102, 153);
    text-align: center;
    line-height: 42px;
    border-radius: 18px;
    margin: auto;
    margin-top: 20px;
    cursor: pointer;
  }
}
.vip-content {
  display: flex;
  justify-content: center;
  gap: 2%;
  .vc-i {
    width: 23%;
    border: 1px solid #c1c1c1;
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    &.active,
    &:hover {
      border: 1px solid rgb(255, 102, 153);
      background: rgb(255, 102, 153);
      .vc-item {
        color: #fff;
        i {
          color: #fff;
        }
        .vc-item-num {
          color: #fff;
        }
      }
      .vc-title {
        color: #fff;
      }
      .price {
        color: #fff;
      }
    }
    .vc-title {
      text-align: center;
      font-size: 20px;
      height: 30px;
      line-height: 30px;
    }
    .price {
      text-align: center;
      font-size: 24px;
      height: 42px;
      line-height: 42px;
    }
    .vc-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      line-height: 32px;
      font-size: 13px;
      i {
        color: rgb(255, 102, 153);
      }
    }
    .vc-item-num {
      color: rgb(255, 102, 153);
    }
  }
}
</style>
<style>
.el-popover.el-popper {
  width: 260px !important;
}
.el-switch__core:after {
  top: 1.5px !important;
}
</style>